// frontend/src/components/ProjectForm.js

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import './ProjectForm.css';

function ProjectForm() {
  const [name, setName] = useState('');
  const [surveyObjective, setSurveyObjective] = useState('');
  const [additionalContext, setAdditionalContext] = useState('');
  const [welcomeHeading, setWelcomeHeading] = useState('');
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    api.post('/projects', {
      name,
      survey_objective: surveyObjective,
      additional_context: additionalContext,
      welcome_heading: welcomeHeading,
      welcome_message: welcomeMessage
    })
      .then(response => {
        navigate(`/dashboard/projects/${response.data.project_id}`);
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.msg) {
          setError(`Failed to create project: ${error.response.data.msg}`);
        } else {
          setError('Failed to create project');
        }
      });
  };

  const autoResize = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  useEffect(() => {
    document.querySelectorAll('textarea').forEach(textarea => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    });
  }, []);

  return (
    <div className="project-form">
      <h2>Create New Project</h2>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="setup-section">
          <div className="setup-item">
            <div className="setup-label">Project Name</div>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="borderless-input"
              placeholder="Internal project name"
              required
            />
          </div>
          <div className="setup-item">
            <div className="setup-label">Survey Objective</div>
            <textarea
              value={surveyObjective}
              onChange={e => {
                setSurveyObjective(e.target.value);
                autoResize(e);
              }}
              onInput={autoResize}
              className="borderless-textarea"
              placeholder="To understand customers' satisfaction with their overall experience..."
              required
            />
          </div>
          <div className="setup-item">
            <div className="setup-label">Additional Context (Optional)</div>
            <textarea
              value={additionalContext}
              onChange={e => {
                setAdditionalContext(e.target.value);
                autoResize(e);
              }}
              onInput={autoResize}
              className="borderless-textarea"
              placeholder="Additional context about the company, product, or service"
            />
          </div>
        </div>
        <div className="setup-section">
          <div className="setup-item">
            <div className="setup-label">Welcome Heading</div>
            <input
              type="text"
              value={welcomeHeading}
              onChange={e => setWelcomeHeading(e.target.value)}
              className="borderless-input"
              placeholder="Enter welcome heading (shown to respondents)"
              required
            />
          </div>
          <div className="setup-item">
            <div className="setup-label">Welcome Message</div>
            <textarea
              value={welcomeMessage}
              onChange={e => {
                setWelcomeMessage(e.target.value);
                autoResize(e);
              }}
              onInput={autoResize}
              className="borderless-textarea"
              placeholder="Enter welcome message (shown to respondents)"
              required
            />
          </div>
        </div>
        <button type="submit" className="submit-button">Create Project</button>
      </form>
    </div>
  );
}

export default ProjectForm;